import { StorageRootDto } from '..';
import { ValueEncoder } from 'DiscoveryEngine.TS/Utils';


export class TenantDto extends StorageRootDto {

    public Name: string;
    
    constructor() {
        super();

        this.Name = "";
     }

    public get HasName(): boolean {
        return !!this.Name;
    }
    
	public Write(obj: any, context: any): void {
		obj.tenant = {};
		obj = obj.tenant;

		super.Write(obj, context);

		if (this.HasName) {
			obj.name = this.Name;
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.tenant)
			throw new Error();
		obj = obj.tenant;

		super.Read(obj, context);

		if (obj.name !== undefined) {
			this.Name = obj.name;
		}
	}
}
